import { ModalCustom } from "@/components/Common"
import { Button } from "@/components/ui/button"
import { setOpenModalCashRegisterHistoric } from "@/store/modalsReducers/modalSlice"
import { useAppDispatch, useAppSelector } from "@/store/store"
import { FileText } from "lucide-react"
import React from "react"

export const CashRegisterHistoricModal: React.FC = () => {
  const dispatch = useAppDispatch()
  const { openModalCashRegisterHistoric } = useAppSelector(
    (state) => state.modal
  )

  const handleClose = () => {
    dispatch(setOpenModalCashRegisterHistoric({ isOpen: false }))
  }

  return (
    <ModalCustom
      isOpen={openModalCashRegisterHistoric.isOpen}
      onClose={handleClose}
      maxWidth={90}
      maxHeight={90}
    >
      <div className="flex flex-col flex-1">
        {/* Header personnalisé */}
        <div className="flex items-center justify-between mb-6 border-b border-gray-200 dark:border-gray-700 p-6">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-100 dark:bg-amber-900/30 rounded-lg">
              <FileText className="h-5 w-5 text-amber-600 dark:text-amber-400" />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
                Historique des Factures
              </h2>
              <p className="text-sm text-gray-600 dark:text-gray-400">
                Consultation et gestion de toutes les factures émises
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleClose}
            className="h-8 w-8 p-0"
          >
            ✕
          </Button>
        </div>

        <div className="text-center text-gray-500 dark:text-gray-400 p-6 flex-1 flex-col items-center justify-center">
          <FileText className="h-16 w-16 mx-auto mb-4 opacity-50" />
          <p className="text-lg font-medium mb-2">
            Modale en cours de développement
          </p>
          <p className="text-sm">
            Cette interface permettra de consulter l'historique des factures
          </p>
        </div>
      </div>
    </ModalCustom>
  )
}
